// eslint-disable-next-line import/prefer-default-export
export const formData = (fields) => {
  const data = {};
  Object.keys(fields).forEach((field) => {
    data[field] = fields[field].value;
  });
  return data;
};
